import { createContext, useContext } from "react";

/** Set to "1" in a browser's localStorage to see what the assistant's sandbox calls ran. */
export const DEBUG_KEY = "steddy.agent.debug";

/** Debug views (a call's code): on in development, else when this browser asks for them (D8). */
function debugDefault(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return window.localStorage.getItem(DEBUG_KEY) === "1";
  } catch {
    return false;
  }
}

/** Read once, at load: a change to the setting shows after a reload. */
const DEBUG = debugDefault();

/** Overrides the default below it: the gallery and tests show both. */
export const DebugContext = createContext<boolean | null>(null);

export function useDebug(): boolean {
  return useContext(DebugContext) ?? DEBUG;
}
